import Base from "@/controllers/base";
export default class Reconciliation extends Base {
  constructor(elem) {
    super(elem);
  }

  toggleHighlight(event) {
    event.target.closest(".tabulator-row").classList.toggle("selected");
  }
}
